import { DatePicker, DayOfWeek, DefaultButton, defaultDatePickerStrings, DialogFooter, Icon, IconButton, IStackTokens, Label, MessageBar, MessageBarType, Modal, PrimaryButton, Spinner, SpinnerSize, Stack, Text, TextField, Toggle, TooltipHost } from "@fluentui/react";
import { useId, useBoolean } from '@fluentui/react-hooks';
import { Field, FieldArray, FieldProps, Form, Formik } from "formik";
import { FormEventHandler, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../../app/Hooks";
import { add, dismissMessage, get, reset, setStage1, update } from "./DocumentsFormSlice";
import * as Yup from 'yup';
import { DynamicInputField, InputField } from "../../controls/Controls";
import { inputs } from "../../../../app/Validation";

import { ClientReadableStream, RpcError, Status } from "grpc-web";
import { PayloadAction } from "@reduxjs/toolkit";
import { ApiMessage, APIRequest, clearSession, getHeaders, getSession, saveSession } from "../../../../app/Api";
import { Message } from "../../../common/Message/Message";
import { useNavigate, useSearchParams } from "react-router-dom";
import { BaseFormProps, FormType, InputFormProps } from "../../FormProps";
import { Int32Value, StringValue } from "google-protobuf/google/protobuf/wrappers_pb";
import { SessionExpiredDialog } from "../../../common/SessionExpiredDialog/SessionExpiredDialog";
import { formatBytes, formatDate, getIconNameFromMime, timestampToDate } from "../../../../app/Helpers";
import { AuthenticateReply } from "../../../../repository/UserManagement/authentication_pb";
import { DynamicField } from "../../../common/DynamicFields/DynamicFields";
import { AddDocumentRequest, AddDocumentResponse, GetDocumentRequest, UpdateDocumentRequest, UpdateDocumentResponse } from "../../../../repository/UserManagement/Managers/document_pb";
import moment from "moment";
import { Timestamp } from "google-protobuf/google/protobuf/timestamp_pb";


let req: AddDocumentRequest;
let updateReq: UpdateDocumentRequest;

let promise: any;

let org: number = -1;
let current: AuthenticateReply.AsObject;

export const DocumentsForm: React.FunctionComponent<BaseFormProps & IStackTokens & InputFormProps> = (props) => {
    const { t, i18n } = useTranslation();
    const dispatch = useAppDispatch()
    const navigate = useNavigate();
    const [showTooltip, setShowTooltip] = useState(false);
    const tooltipId = useId('tooltipId');
    const [searchParams] = useSearchParams();

    const hiddenFileInputRef = useRef<any>(null);

    // 2) Function to trigger the click on the hidden input
    const handleShowFileDialog = () => {
        if (hiddenFileInputRef.current) {
            hiddenFileInputRef.current.click();
        }
    };

    const state: { isLoading: boolean, message: ApiMessage | undefined, stage1: any } = useAppSelector((state) => {

        return { isLoading: state.managementDocumentsForm.isLoading, message: state.managementDocumentsForm.message, stage1: state.managementDocumentsForm.stage1 }
    })

    useEffect(() => {
        var l = searchParams.get('org');
        req = new AddDocumentRequest();
        updateReq = new UpdateDocumentRequest()
        if (l) {
            org = Number(l);
            if (Number.isNaN(org)) {
                org = -1;
            } else {
                const wrapper = new Int32Value();
                wrapper.setValue(org);
                req.setOrganization(wrapper)
            }
        }
        if (props?.renderObject?.userId)
            req.setOwner(props?.renderObject?.userId)

        if (props.type == FormType.EDIT) {
            if (props.fetchData) {
                let r = new GetDocumentRequest()
                r.setId(props?.renderObject?.id);
                promise?.abort()
                promise = dispatch(get({ body: r, headers: getHeaders() }))
            } else {
                dispatch(setStage1(props?.renderObject))
            }
        }


        current = getSession();
        if (!current) {
            clearSession();
            navigate("/login");
        }
        return () => { //clean up
            promise?.abort();
            dispatch(reset());
        }
    }, [])



    return (
        <>

            <Formik
                enableReinitialize={true}
                initialValues={{

                    name: (props.renderObject) ? props.renderObject?.originalName : '',
                    expirationDate: (props.renderObject) ? props.renderObject?.expirationDate ? moment(props.renderObject?.expirationDate, 'YYYY-MM-DD').toDate() : undefined : undefined,
                    extraFields: (state.stage1?.extraFields) ? state.stage1?.extraFields as DynamicField[] : [] as DynamicField[],
                    attachments: []

                }}

                validationSchema={Yup.object({

                    name: inputs.documentName,
                    extraFields: inputs.extraFields,

                })}

                onSubmit={(values, actions) => {
                    if (props.type == FormType.ADD) {
                        if (values.attachments.length == 0) {
                            actions.setFieldError("attachments", t("fileRequred"))
                            return
                        }
                        req.setName(values.name.trim());
                        const extraField: ExtraField[] = [];
                        const count: Number = 1;
                        values.extraFields.forEach((e: DynamicField) => {
                            const r = new ExtraField();
                            r.setKey(e.key);
                            r.setLabel(e.label?.trim() ?? "")
                            r.setType(1)
                            r.setValue(e.value.trim())
                            extraField.push(r)
                        })
                        req.setExtrafieldsList(extraField)
                        if (values.expirationDate) {
                            const wrapper = new Timestamp();
                            wrapper.fromDate(moment(values.expirationDate, 'YYYY-MM-DD').startOf('day').toDate())
                            req.setExpirationdate(wrapper)
                        }
                        let ext = ""
                        let size = "";
                        if (values.attachments.length > 0) {
                            const file: any = values.attachments[0];
                            req.setFile(file.file)
                            req.setMime(file.mime)
                            size = file.size
                            ext = file.ext



                        }

                        promise = dispatch(add({ body: req, headers: getHeaders() }))
                        promise.unwrap()
                            .then((res: AddDocumentResponse.AsObject) => {
                                if (res) {
                                    if (props?.onSuccess) {
                                        props?.onSuccess({
                                            id: res.success?.id,
                                            originalName: values.name.trim(),
                                            size: size,
                                            ext: ext,
                                            expirationDate: values.expirationDate ? formatDate(moment(values.expirationDate, 'YYYY-MM-DD').startOf('day').toDate(), "YYYY-MM-DD") : undefined,
                                            createdDate: formatDate(timestampToDate(res.success?.createddate?.seconds, res.success?.createddate?.nanos)),
                                            addedBy: (current.profile?.firstname?.value ?? "") + " " + (current.profile?.lastname?.value ?? ""),
                                            addedById: current.profile?.id?.value,
                                        });
                                    }
                                }
                                actions.setSubmitting(false)

                            })
                            .catch((error: ApiMessage) => {
                                actions.setSubmitting(false)
                            })
                    } else {
                        updateReq.setName(values.name.trim());
                        if (values.expirationDate) {
                            const wrapper = new Timestamp();
                            wrapper.fromDate(moment(values.expirationDate, 'YYYY-MM-DD').startOf('day').toDate())
                            updateReq.setExpirationdate(wrapper)
                        }

                        const extraField: ExtraField[] = [];
                        const count: Number = 1;

                        values.extraFields.forEach((e: DynamicField) => {
                            const r = new ExtraField();
                            r.setKey(e.key);
                            r.setLabel(e.label?.trim() ?? "")
                            r.setType(1)
                            r.setValue(e.value.trim())
                            extraField.push(r)
                        })
                        updateReq.setExtrafieldsList(extraField)
                        updateReq.setId(props.renderObject?.id)
                        promise = dispatch(update({ body: updateReq, headers: getHeaders() }))
                        promise.unwrap()
                            .then((res: UpdateDocumentResponse.AsObject) => {
                                if (res) {
                                    if (props?.onSuccess) {
                                        props?.onSuccess({
                                            ...props.renderObject,
                                            originalName: values.name.trim(),
                                            expirationDate: values.expirationDate ? formatDate(moment(values.expirationDate, 'YYYY-MM-DD').startOf('day').toDate(), "YYYY-MM-DD") : undefined,

                                            extraFields: values.extraFields
                                        });
                                    }
                                }
                                actions.setSubmitting(false)

                            })
                            .catch((error: ApiMessage) => {
                                actions.setSubmitting(false)
                            })
                    }
                }
                }

            >
                {formkikProps => (
                    <Form >
                        <Stack tokens={{ childrenGap: props.childrenGap, maxWidth: props.maxWidth, padding: props.padding, maxHeight: props.maxHeight }}    >
                            {state.message != undefined ? (state.message.data != 401) ? <Message
                                body={state.message.body}
                                title={state.message.title}
                                data={state.message.data}
                                onDismiss={() => { dispatch(dismissMessage()) }}
                                type={state.message.type}
                            /> :
                                <SessionExpiredDialog />
                                : null
                            }
                            <Field name="name" label={t("fileName")} placeholder={t("fileNameHint")} component={InputField} disabled={state.isLoading} autoFocus maxLength={50} required />

                            <Toggle

                                onText={t("enabled")} offText={t("disabled")}
                                label={t("setConfirmationExpirationDate")}
                                disabled={state.isLoading}
                                checked={formkikProps.values.expirationDate != undefined}
                                onChange={(ev: React.MouseEvent<HTMLElement>, checked?: boolean) => {
                                    if (checked == true) {
                                        if (formkikProps.values.expirationDate != undefined) {
                                            formkikProps.setFieldValue('expirationDate', formkikProps.values.expirationDate);
                                        } else {
                                            formkikProps.setFieldValue('expirationDate', new Date());
                                        }
                                    } else {
                                        formkikProps.setFieldValue('expirationDate', undefined);
                                    }
                                }
                                }
                            />

                            {formkikProps.values.expirationDate != undefined ? <DatePicker
                                isRequired
                                firstDayOfWeek={DayOfWeek.Sunday}
                                label={t("expirationDate")}
                                placeholder={t("expirationDate")}
                                disabled={state.isLoading}
                                value={formkikProps.values.expirationDate}
                                ariaLabel={t("to")}
                                formatDate={(e) => {
                                    return formatDate(e, 'YYYY-MM-DD')
                                }}
                                parseDateFromString={(date) => {
                                    return moment(date, 'YYYY-MM-DD').endOf('day').toDate();
                                }}
                                // DatePicker uses English strings by default. For localized apps, you must override this prop.
                                strings={defaultDatePickerStrings}
                                onSelectDate={(date: Date | null | undefined) => {
                                    if (date != undefined)
                                        formkikProps.setFieldValue("expirationDate", date)

                                }}

                            /> : undefined}
                            {props.type == FormType.ADD ? <Stack.Item>
                                <Label required disabled={state.isLoading}>{
                                    t("document")
                                }</Label>
                                <FieldArray
                                    name="attachments"
                                    validateOnChange={false}

                                >
                                    {arrayHelpers => {
                                        let r = [] as React.ReactNode[];
                                        if (formkikProps.values.attachments && formkikProps.values.attachments.length > 0) {

                                            r.push(formkikProps.values.attachments.map((row: any, rowIndex) => {

                                                return (<Stack
                                                    horizontal
                                                    verticalAlign="center"
                                                    styles={{ root: { padding: 8, border: '1px solid #ccc', borderRadius: 4, maxWidth: 300 } }}
                                                    tokens={{ childrenGap: 8 }}
                                                >

                                                    <Icon iconName={getIconNameFromMime(row.mime)} styles={{ root: { fontSize: 24 } }} />

                                                    <Stack.Item grow>
                                                        <Stack>
                                                            <Text variant="mediumPlus" styles={{
                                                                root: {
                                                                    fontWeight: 600,
                                                                    // Truncation properties
                                                                    whiteSpace: 'nowrap',
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis',
                                                                    maxWidth: 150,
                                                                    display: 'inline-block',
                                                                }
                                                            }}>
                                                                {row.originalName}
                                                            </Text>
                                                            <Text variant="small">{formatBytes(row.size)}</Text>
                                                        </Stack>
                                                    </Stack.Item>
                                                    {row.isLoading ? <Spinner size={SpinnerSize.large} /> : <IconButton
                                                        iconProps={{ iconName: 'Cancel' }}
                                                        title={t("cancel")}
                                                        ariaLabel={t("cancel")}
                                                        disabled={state.isLoading}
                                                        onClick={() => {
                                                            formkikProps.setFieldValue("attachments", [])

                                                        }}
                                                        styles={{ root: { marginLeft: 4 } }}
                                                    />}
                                                </Stack>

                                                )
                                            })
                                            )

                                        }
                                        if (formkikProps.values.attachments.length < 1) {
                                            const ALLOWED_EXTENSIONS = [
                                                '.jpg',
                                                '.jpeg',
                                                '.png',
                                                '.pdf',
                                                '.txt',
                                                '.doc',
                                                '.docx',
                                                '.xls',
                                                '.xlsx',
                                                '.heif',
                                                '.heic',
                                            ];

                                            r.push(<IconButton disabled={state.isLoading}
                                                key={"addButton"} iconProps={{ iconName: "add" }} onClick={() => {

                                                    handleShowFileDialog();

                                                }} >

                                                <input
                                                    type="file"
                                                    ref={hiddenFileInputRef}
                                                    style={{ display: "none" }}
                                                    accept={ALLOWED_EXTENSIONS.join(',')}
                                                    onChange={(e: any) => {
                                                        if (e.target.files && e.target.files.length > 0) {
                                                            // For example, push a new item with these files

                                                            //arrayHelpers.push({ key: (formkikProps.values.attachments.length + 1) + "", label: undefined, type: 1, value: event.target.files, autoFocus: false })

                                                            const [file] = e.target.files;
                                                            const reader = new FileReader();
                                                            reader.readAsArrayBuffer(file);
                                                            if (file.size > 8000000) {
                                                                //alert("File size must not exceed 5 MB.");
                                                                // Optional: reset the input if you want to clear it
                                                                //e.target.value = null; 
                                                                formkikProps.setFieldError("attachments", t("fileSizeLimit"))
                                                                return;
                                                            }
                                                            reader.onloadend = (evt) => {
                                                                if (evt?.target?.readyState === FileReader.DONE) {
                                                                    const arrayBuffer = evt.target.result;
                                                                    let array = new Uint8Array(arrayBuffer as ArrayBuffer);
                                                                    const mimeType = file.type || ""; // If the type isn't recognized, it may be ""
                                                                    let ext = ""
                                                                    let fullName = "file"
                                                                    var r = file.name?.split(".")
                                                                    try {
                                                                        fullName = r[0]
                                                                    } catch {
                                                                    }
                                                                    try {
                                                                        ext = r[r.length - 1]
                                                                    } catch {

                                                                    }
                                                                    formkikProps.setFieldValue("attachments", [{ mime: mimeType, ext: ext, size: (file.size ?? 0), originalName: fullName, file: array }])


                                                                }
                                                            }
                                                        }
                                                        e.target.value = ''
                                                        //handleFilesChange(event.target.files, arrayHelpers)

                                                    }

                                                    }
                                                // If you do NOT want multiple, remove the `multiple` attribute above
                                                />

                                            </IconButton>)
                                        }
                                        return r;
                                    }
                                    }

                                </FieldArray>
                            </Stack.Item> : undefined}



                            <Label disabled={state.isLoading}>{
                                <div>
                                    {t("extraFields") + ' '}
                                    <TooltipHost content={t("extraInformationDescription")}>
                                        <Icon iconName="Info" aria-label={t("extraFields")} />
                                    </TooltipHost>
                                </div>
                            }</Label>
                            <FieldArray
                                name="extraFields"
                                validateOnChange={false}

                            >
                                {arrayHelpers => {
                                    let r = [] as React.ReactNode[];
                                    if (formkikProps.values.extraFields && formkikProps.values.extraFields.length > 0) {
                                        r = formkikProps.values.extraFields.map((o, index) => {
                                            if (o.type == 1) {
                                                return (<Stack horizontal horizontalAlign="space-between" tokens={{ childrenGap: props.childrenGap }} key={index}>
                                                    {o.label != undefined ? <Stack.Item grow> <DynamicInputField name={`extraFields[${index}].label`} placeholder={t("extraFieldLabel")} disabled={state.isLoading}
                                                        maxLength={50} autoFocus={(o as any)?.autoFocus} /> </Stack.Item> : null}
                                                    <Stack.Item grow>  <DynamicInputField name={`extraFields[${index}].value`} placeholder={t("extraFieldValue")} disabled={state.isLoading}
                                                        maxLength={50}
                                                    /></Stack.Item>

                                                    <IconButton disabled={state.isLoading}
                                                        iconProps={{ iconName: "remove" }} onClick={() => {
                                                            arrayHelpers.remove(index)
                                                        }} />
                                                </Stack>)
                                            }
                                        }
                                        )
                                    }
                                    if (formkikProps.values.extraFields.length <= 4) {
                                        r.push(< IconButton disabled={state.isLoading}
                                            key={"addButton"} iconProps={{ iconName: "add" }} onClick={() => {
                                                arrayHelpers.push({ key: (formkikProps.values.extraFields.length + 1) + "", label: "", type: 1, value: "", autoFocus: true })
                                            }} />)
                                    }
                                    return r;
                                }
                                }

                            </FieldArray>
                        </Stack>
                        <DialogFooter>
                            <PrimaryButton disabled={state.isLoading} text={state.isLoading ? undefined : props.type == FormType.ADD ? t("add") : t("edit")} type="submit" >

                                <Spinner size={SpinnerSize.medium} styles={{ root: { display: (state.isLoading ? "block" : "none") } }} />

                            </PrimaryButton>
                            <DefaultButton disabled={state.isLoading} text={props.type == FormType.ADD ? t("discard") : t("cancel")} onClick={() => {
                                if (props.onCancel) {
                                    formkikProps.resetForm()
                                    props.onCancel()
                                }
                            }} />
                        </DialogFooter>

                    </Form>
                )}
            </Formik >
        </>
    );

}

